import styles from "./Intro.module.scss";
import buttonStyles from "../../../components/Button.module.scss";

const Intro = () => {
  return (
    <section id="intro" className={styles.intro}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <h1>
            International Reformed
            <br />
            Evangelical Church
          </h1>
          <h3>in Stockholm</h3>
        </div>
        <div className={styles.desc}>
          <p>
            We are Bible-believing, Reformed church that aims to share the
            Gospel to the people in Stockholm. Join us on Sundays for worship.
          </p>
          <a href="/service" className={buttonStyles.button}>
            Find us
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
